<template>
  <div>
    <v-layout v-if="!dialog" wrap>
      <v-flex xs12 md12 style="margin-top: 10px">
        <v-card :outlined="true">
          <v-card-title>
            {{ tabName }}
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="ค้นหา"
              style="margin-right: 2%"
              :hide-details="true"
              @keydown.enter="_getByQuery"
            ></v-text-field>
          </v-card-title>

          <v-card-text>
            <v-card class="mb-4">
              <v-card-text>
                <v-data-table
                  class="clean-tb"
                  item-key="index"
                  :headers="headers"
                  :items="items"
                  :footer-props="{ 'items-per-page-options': $itemsPerPage }"
                  :items-per-page="perPage"
                  :loading="loading"
                  :options.sync="options"
                  :server-items-length="countItems"
                  no-data-text="ไม่พบข้อมูลหรือไม่มีสิทธิเข้าถึงข้อมูล"
                  no-results-text="ไม่พบข้อมูลหรือไม่มีสิทธิเข้าถึงข้อมูล"
                >
                  <template v-slot:item.name="{ item }">
                    {{ _fullName(item) }}
                  </template>
                  <template v-slot:item.picture="{ item }">
                    <v-img :src="item.picture" width="100" contain />
                  </template>
                  <template v-slot:item.registered="{ item }">
                    <span v-html="_registered(item.registered)"></span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      data-testid="unlink-btn"
                      class="mx-2 float-right"
                      :loading="loading"
                      :disabled="loading || item.registered !== true"
                      color="#F4CCCC"
                      @click="_unlink(item)"
                    >
                      Unlink
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <div>------------------------------------- Confirm Dialog  -----------------------------------------------------</div> -->

    <v-dialog v-model="confirm.status" max-width="800" scrollable persistent>
      <v-card>
        <v-card-title class="headline"
          >Confirm {{ confirm.type }}?</v-card-title
        >
        <v-card-text
          >Are you sure you want to {{ confirm.type }}
          {{ (confirm.data && confirm.data.name) || "this" }}.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            :loading="loading"
            @click="confirm.status = false"
            text
            >Cancel</v-btn
          >
          <v-btn
            :color="(confirm.type === 'sync' && 'success') || 'error'"
            :loading="loading"
            @click="_confirm"
            text
            >{{ confirm.type }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NetworkShop from "@/store/models/changtt/networkShop";

const formDefault = {
  filter: [{}],
  dateType: "date",
  dateContent: {},
  type: "list",
};

export default {
  name: "NetworkShop",
  props: ["user", "tabName"],
  data() {
    return {
      search: "",
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [true],
      },
      perPage: 10,
      countItems: 0,
      confirm: {
        status: false,
      },
      headers: [
        { text: "ชื่อ-นามสกุล", value: "name", sortable: false },
        { text: "เบอร์โทรศัพท์", value: "phone", sortable: false },
        { text: "อีเมล์", value: "email", sortable: false },
        { text: "โปรไฟล์ LineOA", value: "picture", sortable: false },
        { text: "สถานะไลน์", value: "registered", sortable: false },
        {
          text: "",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      items: [],
      dialog: false,
      form: formDefault,
    };
  },
  watch: {
    options: {
      handler(ne, pe) {
        // Page
        if (ne.page != pe.page || ne.itemsPerPage != pe.itemsPerPage) {
          this.fetchData();
        }

        // Sort
        if (ne.sortBy[0] != pe.sortBy[0] || ne.sortDesc[0] != pe.sortDesc[0]) {
          this.fetchData();
        }
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      let options = { params: {} };

      if (this.search) {
        options.params.query = this.search;
      }

      if (this.options && this.options.itemsPerPage) {
        options.params.perPage = this.options.itemsPerPage;
      } else {
        options.params.perPage = 10;
      }

      if (this.options && this.options.page) {
        options.params.page = this.options.page;
      }

      const res = await NetworkShop.list(options);
      this.items = (res && res.data) || [];
      this.countItems = res && res.total;
      this.loading = false;
    },
    _getByQuery() {
      this.selected = null;
      this.options.page = 1;
      this.fetchData();
    },
    _fullName(item = {}) {
      return `${item.firstName}${item.lastName ? " " + item.lastName : ""}`;
    },
    _registered(registered = false) {
      return registered
        ? '<span style="color: #1f9812;">ลงทะเบียนแล้ว</span>'
        : '<span style="color: #ff0000;">ยังไม่ได้ลงทะเบียน</span>';
    },
    _unlink(data = {}) {
      this.confirm = {
        status: true,
        type: "unlink",
        data,
      };
    },
    async _confirm() {
      this.loading = true;
      this.confirm.status = false;
      const confirm = this.confirm;
      const data = confirm.data || {};

      let res;
      if (confirm.type === "unlink") {
        const form = {
          userId: data.id,
        };

        res = await NetworkShop.unlink({ data: form }).catch((err) =>
          console.error(err),
        );
      }
      if (res) {
        this.fetchData();
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.theme--light.v-sheet--outlined {
  border: none !important;
}
</style>
